import script from "./WebinarRegistrantsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarRegistrantsModal.vue?vue&type=script&setup=true&lang=js"

import "./WebinarRegistrantsModal.vue?vue&type=style&index=0&id=0f5c4598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f5c4598"]])

export default __exports__